<template>
  <div class="content">
    <h1 class="is-hidden">Tabellen</h1>
    <div class="box">
      <h2 class="has-text-centered">Schaltzeichen</h2>
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-protective-earth'}" class="inherited">
                  <div class="p-2">
                    Schutzleiter und Masse
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-ideal-circuits'}" class="inherited">
                  <div class="p-2">
                    Ideale Stromkreise
                  </div>
                </router-link>
              </td>
            </tr>
            <!--
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-constants'}" class="inherited">
                  <div class="p-2">
                    Wandler
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-greek-alphabet'}" class="inherited">
                  <div class="p-2">
                    Filter
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-ascii-characters'}" class="inherited">
                  <div class="p-2">
                    Leiter
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-electrical-resistivity'}" class="inherited">
                  <div class="p-2">
                    Sicherungen
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-si-units'}" class="inherited">
                  <div class="p-2">
                    Schutzschalter
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-constants'}" class="inherited">
                  <div class="p-2">
                    Überspannungsableiter
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-greek-alphabet'}" class="inherited">
                  <div class="p-2">
                    Gehäuse
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-ascii-characters'}" class="inherited">
                  <div class="p-2">
                    Akkumulatoren
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-electrical-resistivity'}" class="inherited">
                  <div class="p-2">
                    Elektrische Bauelemente
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-units-prefixes'}" class="inherited">
                  <div class="p-2">
                    Dioden
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-si-units'}" class="inherited">
                  <div class="p-2">
                    Thyristoren
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-constants'}" class="inherited">
                  <div class="p-2">
                    Photoelemente
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-greek-alphabet'}" class="inherited">
                  <div class="p-2">
                    Transistoren
                  </div>
                </router-link>
              </td>
            </tr>
            -->
          </tbody>
        </table>
      </div>
    </div>
    <div class="box">
      <h2 class="has-text-centered">Sonstige</h2>
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-units-prefixes'}" class="inherited">
                  <div class="p-2">
                    Einheitenvorsätze
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-si-units'}" class="inherited">
                  <div class="p-2">
                    Internationales Einheitensystem SI
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-constants'}" class="inherited">
                  <div class="p-2">
                    Konstanten
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-greek-alphabet'}" class="inherited">
                  <div class="p-2">
                    Griechische Buchstaben
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-ascii-characters'}" class="inherited">
                  <div class="p-2">
                    ASCII Zeichen
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'tables-electrical-resistivity'}" class="inherited">
                  <div class="p-2">
                    Spezifische Widerstände
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-tables',
  metaInfo: {
    title: 'Elektrotechnik Tabellen | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Sammlung einiger nützlicher Tabellen ✓ ASCII-Zeichentabelle ✓ SI-Einheiten ✓ Spezifische Widerstände ➤ Und mehr!'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Tabellen', route: 'start' })
  }
}
</script>
